import { AppState } from '../../sew-core/types/index';
import { connect, } from 'react-redux';
import ExpertRatingPanel from '../components/ExpertRatingPanel';

const mapStateToProps = (state: AppState) => ({
  expertReviewAndRating: state.expertReviewAndRating,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ExpertRatingPanel);
